import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 10: Authenticity</h1>
          <p className="white"><b>How to connect to your true self</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Reflect on who you think you are as a person. Ask yourself:
              <ul>
                <li style={{listStyleType:"none"}}>What do I believe in?</li>
                <li style={{listStyleType:"none"}}>What are my values?</li>
                <li style={{listStyleType:"none"}}>What do I like/love about myself?</li>
                <li style={{listStyleType:"none"}}>What kind of person am I?</li>
                <li style={{listStyleType:"none"}}>If I were to die tomorrow, how would I want to be described in my obituary?</li>
              </ul>
            </li>
            <li>Be honest with yourself and really give this some thought. Are you currently living in alignment with your answers? Reflect on how you act, speak, and think on the day-to-day. Is there a gap between who you think you are (or want to be) and how you behave consistently? Examine the actions that shape that definition.
            </li>
            <li>What are your daily habits that contribute to making you who you are at present? Be sure to look at the intentional and unintentional habits that make up your regular behaviors.
            </li>
            <li>Think of characteristics and values that constitute the absolute best version of yourself, the self you want to be known as. Are they in line with what you thought of for Question #1?
            </li>
            <li>What can you regularly do to be true to the best version of yourself? How do you need to think, act, and speak on an ongoing basis? What are the habits you need to change to support your ideal self?
            </li>
            <li>Repeatedly and consistently think, speak, and act in a way that your best self would think, speak, and act.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter10.js